import { css } from '@linaria/core'
import CheckIcon from '#icons/check-24.svg'
import { fragments, style } from '#styles/index'

export const cosimaDocumentClass = css`
  background: ${style.themeColors.backgroundPopout};
  max-width: 100%;
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  gap: 24px;

  p {
    margin-bottom: 8px;
  }

  ._cosima-list {
    /* html too bad for real markers */
    list-style-type: none;

    ::marker {
      /* html too bad for real markers */
      display: none;
    }

    > li._cosima-list-item {
      position: relative;

      > p {
        display: flex;
        gap: 8px;

        &:before {
          /* marker */
          flex-shrink: 0;
          content: " ";
          display: block;
          height: 6px;
          width: 6px;
          margin-left: 4px;
          margin-top: 10px;
          background-color: ${style.themeColors.textImportant};
        }
      }
    }
  }

  ._cosima-paragraph > ._cosima-paragraph {
    display: contents;
  }

  ._cosima-superscript {
    position: relative;
    top: -0.5em;
    font-size: 80%;
  }

  ._cosima-subscript {
    position: relative;
    bottom: -0.5em;
    font-size: 80%;
  }

  > ._cosima-meta-figure {
    margin: auto;

    > ._cosima-image {
      max-height: 350px;
      max-width: 100%;
    }
  }

  > ._cosima-headline {
    padding-top: 12px;
    display: flex;
    flex-direction: row;
    gap: 12px;

    > ._cosima-code {
      ${fragments.textStyle.heading.xl.regular}
    }
    > ._cosima-name {
      ${fragments.textStyle.heading.xl.subtle}
    }
  }

  > ._cosima-short-description {
    padding-top: 24px;
    ${fragments.textStyle.body.l.bold}
  }

  ._cosima-benefits {
    /* benefit check list */
    padding-top: 24px;

    > h1 {
      ${fragments.textStyle.heading.l.regular}
      color: ${style.themeColors.textImportant};
      text-transform: uppercase;
    }

    > ._cosima-list-title {
      padding-top: 8px;
      ${fragments.textStyle.heading.m.regular}
      color: ${style.themeColors.textDefault}
    }

    > ul {
      display: flex;
      flex-direction: column;
      gap: 8px;

      > li._cosima-list-item {
        padding-left: 0;
        display: flex;
        gap: 4px;

        > p:before {
          /* marker with checkmarks */
          width: 16px;
          height: 16px;
          margin-top: 4px;
          mask-image: url(${CheckIcon});
          mask-size: 100%;
          mask-position: center center;
          mask-repeat: no-repeat;
          mask-size: contain;
        }
      }
    }
  }

  > ._cosima-description {
    padding-top: 24px;
    > h1 {
      ${fragments.textStyle.heading.l.regular}
      text-transform: uppercase;
    }

    > ._cosima-description-block {
      > ._cosima-title {
        ${fragments.textStyle.heading.m.regular}
        padding-top: 8px;
      }
    }
  }

  > ._cosima-technical-data {
    padding-top: 24px;
    > h1 {
      ${fragments.textStyle.heading.l.regular}
      text-transform: uppercase;
    }
  }

  ._cosima-table {
    > ._cosima-table-title {
      ${fragments.textStyle.heading.m.regular}
    }

    > ._cosima-grid {
      display: grid;

      > ._cosima-header {
        display: contents;

        > ._cosima-row {
          display: contents;
        }

        ${fragments.textStyle.body.l.bold}
        margin-bottom: 12px;
      }

      > ._cosima-body {
        > ._cosima-row {
          display: contents;

          > ._cosima-entry {
            border-bottom: 1px solid ${style.themeColors.lineDefault};
            min-height: 12px;
          }
        }
        display: contents;
        ${fragments.textStyle.body.m.regular}
      }
    }
  }

  ._cosima-vcode-link {
    ${fragments.textStyle.body.l.regular};
    color: ${style.themeColors.textImportant};
  }

  ._cosima-highlight {
    ${fragments.textStyle.body.l.bold};
  }
`
